export default function updateThemeTag(colorcode: string): void {
    document.getElementsByName('theme-color')?.[0].setAttribute('content', colorcode);
}
